import React from 'react';
import MainLayout from '../layouts/MainLayout';
import LeafletMap from '../components/LeafletMap';

export default function About() {
  return (
    <MainLayout>
    About
    <LeafletMap />
  </MainLayout>
  );
}
